import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import BedbankOfferTileCondensed from 'components/OfferList/OfferListTiles/BedbankOfferTileCondensed'
import BedbankOfferTileExpanded from 'components/OfferList/OfferListTiles/BedbankOfferTileExpanded'
import { BEDBANK_PROPERTY_STYLE_LPC } from 'constants/offer'
import useShowNewHotelSearch from 'components/SearchV2/Hooks/useShowNewHotelSearch'
import NewBedbankOfferTileExpanded from './RedesignedSearchTiles/NewBedbankOfferTileExpanded'
import NewBedbankOfferTileCondensed from './RedesignedSearchTiles/NewBedbankOfferTileCondensed'

const Root = styled(Pane)`
  position: relative;
`

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary;
  filters?: App.OfferListFilters;
  eagerLoadFirstImage?: boolean;
  offerUrl: string;
}

function SearchBedbankOffer(props: Props) {
  const { offer, filters, eagerLoadFirstImage, offerUrl } = props

  const showExpandedTile = config.BEDBANK_EXPANDED_SEARCH_OFFER_TILE_ENABLED && offer.style === BEDBANK_PROPERTY_STYLE_LPC

  const showNewSearchTile = useShowNewHotelSearch()

  return <Root type="clean">
    {showExpandedTile && !showNewSearchTile && <BedbankOfferTileExpanded
      offer={offer as App.BedbankOffer | App.BedbankOfferSummary}
      filters={filters}
      eagerLoadFirstImage={eagerLoadFirstImage}
      offerUrl={offerUrl}
     />}
    {showExpandedTile && showNewSearchTile && <NewBedbankOfferTileExpanded
       offer={offer as App.BedbankOffer | App.BedbankOfferSummary}
       filters={filters}
       eagerLoadFirstImage={eagerLoadFirstImage}
       offerUrl={offerUrl}
      />}
    {!showExpandedTile && !showNewSearchTile && <BedbankOfferTileCondensed
      offer={offer as App.BedbankOffer | App.BedbankOfferSummary}
      filters={filters}
      eagerLoadFirstImage={eagerLoadFirstImage}
      offerUrl={offerUrl}
    />}
    {!showExpandedTile && showNewSearchTile && <NewBedbankOfferTileCondensed
      offer={offer as App.BedbankOffer | App.BedbankOfferSummary}
      filters={filters}
      eagerLoadFirstImage={eagerLoadFirstImage}
      offerUrl={offerUrl}
    />}
  </Root>
}

export default SearchBedbankOffer
